import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Edit,
  Create,
  Filter,
  required,
  DateField,
  CardActions,
  ListButton,
  CreateButton,
  SearchInput
} from 'react-admin'

import rowStyle from './rowStyle'

const CreateActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
  </CardActions>
)

const EditActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
    <CreateButton basePath={basePath} record={data} />
  </CardActions>
)

const School = {
  filter: (props) => (
    <Filter {...props}>
      <SearchInput label='Search by name' source='name' alwaysOn />
      <SearchInput label='Search by pin' source='pin' />
    </Filter>
  ),
  create: (props) => (
    <Create {...props} actions={<CreateActions />}>
      <SimpleForm>
        <TextInput source='name' label='Name' validate={required()} />
      </SimpleForm>
    </Create>
  ),
  edit: (props) => {
    return (
      <Edit {...props} actions={<EditActions />}>
        <SimpleForm>
          <TextField source='id' />
          <TextInput source='name' label='Name' validate={required()} />
          <TextInput source='pin' validate={required()} />
          <DateField source='createdAt' showTime />
          <DateField source='updatedAt' showTime />
        </SimpleForm>
      </Edit>
    )
  },
  list: (props) => (
    <List filters={<School.filter />} {...props}>
      <Datagrid
        rowStyle={rowStyle}
        rowClick='edit'
      >
        <TextField source='name' label='Name' />
        <TextField source='pin' label='Pin' />
        <DateField source='createdAt' />
        <DateField source='updatedAt' />
      </Datagrid>
    </List>
  )
}

export default School
